import { FeatureFlag } from '@ps/web-core-enums';
import { useFeature } from '@ps/web-core-store';
import type { WebsiteConfig } from '@ps/web-martech-cms-types';
import { RawButton, Translation } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import { useTouchpoint } from '@swf/components/Touchpoint';
import type { RootState } from '@swf/core/store';
import { select } from '@swf/core/store';

import { TXTMOB_Give_Feedback } from './RMFFeedbackButton.messages.json';
import styles from './RMFFeedbackButton.scss';

const RMFFeedbackButton: React.FC = () => {
  const skip = !useFeature(FeatureFlag.SwcRmfFeedbackCsat);
  const touchpointRMFConfig = useSelector((rootState: RootState) =>
    select.cms.getWebsiteConfig(rootState, 'touchpoint_rmf')
  ) as WebsiteConfig['touchpoint_rmf'] | undefined;
  const { isReady: isTouchpointReady, show: showTouchpoint } = useTouchpoint(
    skip,
    false,
    touchpointRMFConfig
  );
  const handleShowFeedbackScreen = () => isTouchpointReady && showTouchpoint();

  if (skip) {
    return null;
  }

  return (
    <div className={styles.container}>
      <RawButton
        variant="primary"
        size="large"
        className={styles.button}
        onClick={handleShowFeedbackScreen}
      >
        <Translation {...TXTMOB_Give_Feedback} />
      </RawButton>
    </div>
  );
};

export default RMFFeedbackButton;
